import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    message: '',
    color: '',
    show: false,
    timeout: 3000,
    isVisible: false,
    title: '',
    text: '',
    item: "",
    icon: "",
    confirmButtonText: '',
    denyButtonText: '',
    closeButtonText: '',
    closeButtonColor: "grey4",
    showConfirmButton: false,
    showDenyButton: false,
    showCloseButton: false,
    onConfirm: null,
    onDeny: null,
    onClose: null,
    timerProgressBar: false,
    duration: 5,
    type: 'success',
    isLoading: false,
    customContent: null
  }),

  getters: {
    background: (state) => {
      switch (state.type) {
        case "success":
          return "#EFFBF5";
        case "error":
        case "delete":
          return "#FFF7F5";
        case "info":
          return "#F1FBFE";
        case "warning":
          return "#FFFBEC";
        default:
          return "grey lighten-1";
      }
    },

    modalIcon: (state) => {
      if (state.icon) return state.icon
      switch (state.type) {
        case "success":
          return "solar:check-circle-bold";
        case "error":
          return "solar:close-circle-bold";
        case "delete":
          return "solar:trash-bin-trash-bold"
        case "info":
          return "solar:danger-circle-bold";
        default:
          return "solar:minus-circle-bold";
      }
    },

    iconColor: (state) => {
      switch (state.type) {
        case "success":
          return "#2CAA69";
        case "error":
        case "delete":
          return "#F84C20";
        case "info":
          return "#16AACF";
        case "warning":
          return "#F49C2B";
        default:
          return "grey";
      }
    },

    iconTheme: (state) => {
      switch (state.type) {
        case "success":
          return "radial-gradient(ellipse at center, #A6E8C6 30%, #86DFB1 31%, #A6E8C6 32%, #A6E8C6 37%, #86DFB1 38%, #C2EFD8 39%, #C2EFD8 44%, #E3F8ED 45%, #E3F8ED 50%, #C2EFD8 51%, #C2EFD8 51%, #EFFBF5 52%, #EFFBF5 100%)";
        case "error":
        case "delete":
          return "radial-gradient(ellipse at center, #FDCBBF 30%, #FCB7A6 31%, #FDCBBF 32%, #FDCBBF 37%, #FCB7A6 38%, #FEDBD2 39%, #FEDBD2 44%, #FEEFEB 45%, #FEEFEB 50%, #FEDBD2 51%, #FEDBD2 51%, #FFF7F5 52%, #FFF7F5 100%)";
        case "info":
          return "radial-gradient(ellipse at center, #A3E5F5 30%, #83DBF2 31%, #A3E5F5 32%, #A3E5F5 37%, #83DBF2 38%, #C3EEF9 39%, #C3EEF9 44%, #DFF6FC 45%, #DFF6FC 50%, #C3EEF9 51%, #C3EEF9 51%, #F1FBFE 52%, #F1FBFE 100%)";
        case "warning":
          return "radial-gradient(ellipse at center, #FCD15C 30%, #FABD3D 31%, #FCD15C 32%, #FCD15C 37%, #FABD3D 38%, #FDE591 39%, #FDE591 44%, #FEF2CA 45%, #FEF2CA 50%, #FDE591 51%, #FDE591 51%, #FFFBEC 52%, #F1FBFE 100%)";
        default:
          return "grey";
      }
    },

    confirmBtnTheme: (state) => {
      switch (state.type) {
        case "success":
          return "#2CAA69";
        case "error":
        case "delete":
          return "#FB977D";
        case "info":
          return "#16AACF";
        case "warning":
          return "#4BD08B";
        default:
          return "grey";
      }
    }
  },

  actions: {
    showToast(message: string, color: string = 'success', timeout: number = 3000) {
      this.message = message;
      this.color = color;
      this.timeout = timeout;
      this.show = true;
    },
    hideToast() {
      this.show = false;
    },

    showAlert(options: any) {
      setTimeout(() => {
        this.title = options.title || "";
        this.text = options.text || "";
        this.item = options.item || "";
        this.icon = options.icon || "";
        this.confirmButtonText = options.confirmButtonText || "newConfirmText";
        this.denyButtonText = options.denyButtonText || "newCloseText";
        this.closeButtonText = options.closeButtonText || "close";
        this.closeButtonColor = options.closeButtonColor || "grey4";
        this.showConfirmButton = options.showConfirmButton || false;
        this.showDenyButton = options.showDenyButton || false;
        this.showCloseButton = options.showCloseButton || false;
        this.onConfirm = options.onConfirm;
        this.onDeny = options.onDeny;
        this.onClose = options.onClose;
        this.timerProgressBar = options.timerProgressBar || false;
        this.duration = options.duration || 5;
        this.type = options.type || 'success';
        this.customContent = options.customContent || null;
        this.isVisible = true;
      }, 400);
    },
    async confirm() {
      this.isLoading = true
      if (this.onConfirm) {
        await this.onConfirm();
      }
      this.isVisible = false;
      this.isLoading = false;
    },
    deny() {
      if (this.onDeny) this.onDeny();
      this.isVisible = false;
      this.isLoading = false;
    },
    close() {
      if (this.onClose) this.onClose();
      this.isVisible = false;
      this.isLoading = false;
    }
  },
});
